import { Popover } from '@mantine/core';
import classes from './Popover.module.css';

export const PopoverConfig = Popover.extend({
  defaultProps: {
    arrowRadius: 4,
    arrowSize: 10,
    position: 'bottom',
    transitionProps: {
      transition: 'pop',
    },
  },
  classNames: {
    dropdown: classes.dropdown,
    arrow: classes.arrow,
  },
});
